export abstract class ExternalLinkOpener {
  public abstract open(url: string): Promise<void>
}
